import * as _ from 'lodash';

export const cloneDeep = <T>(value: T): T => {
	return _.cloneDeep(value);
};

export const clone = <T>(value: T): T => {
	return _.clone(value);
};
